import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import dnaWeightTest from "../../assets/images/dna-weight-management-test.png";
import thyroidProfileTest from "../../assets/images/thyroid-profile-test.png";
import energyProfileTest from "../../assets/images/energy-profile-test.png";
import weightManagementTest from "../../assets/images/weight-management-test.png";
import cholesterolProfileTest from "../../assets/images/cholesterol-profile-test.png";

const TestKitCarousel = () => {
  const articles = [
    {
      id: "vitamin-b12-what-you-need-to-know",
      image: thyroidProfileTest,
      title: "Vitamin B12: what you need to know",
      readTime: "5 min read",
      link: "https://myhealthchecked.com/product/thyroid-profile-blood-test",
    },
    {
      id: "why-vitamin-b12-important",
      image: weightManagementTest,
      title: "Why is vitamin B12 important?",
      readTime: "7 min read",
      link: "https://myhealthchecked.com/product/weight-management-blood-test",
    },
    {
      id: "why-vitamin-b12-important",
      image: energyProfileTest,
      title: "Why is vitamin B12 important?",
      readTime: "7 min read",
      link: "https://myhealthchecked.com/product/energy-profile-blood-test",
    },
    {
      id: "why-vitamin-b12-important",
      image: dnaWeightTest,
      title: "Why is vitamin B12 important?",
      readTime: "7 min read",
      link: "https://myhealthchecked.com/product/weight-management-dna-test",
    },
    {
      id: "why-vitamin-b12-important",
      image: cholesterolProfileTest,
      title: "Why is vitamin B12 important?",
      readTime: "7 min read",
      link: "https://myhealthchecked.com/product/cholesterol-profile-blood-test",
    },
  ];

  return (
    <div className="testkit-carousel">
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        autoplay={{
          delay: 5000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        speed={600}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
                breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1050: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 22,
          },
          1366: {
            slidesPerView: 4,
            spaceBetween: 25
          },
        }}
        className="px-2"
      >
        {articles.map((article, index) => (
          <SwiperSlide key={article.id} >
            <a
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <img src={article.image} alt={article.title} style={{
                 height: index === articles.length - 1
                  ? "31vh"        
                  : "30vh",  
                objectFit: "cover",
                borderRadius: "8px"
              }} />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TestKitCarousel;
